import React, { useState } from 'react';
import WhiteLoadingSpinner from '../../../../assets/images/loading-spinner-purple';

const LoadingSpinner = ({ message }) => {
	const [open, setOpen] = useState(false);
	const handleClose = () => {
		setOpen(false);
	};

	return (
		<div
			className="loading-spinner-popup"
			id="loading-spinner-popup"
			open={open}
		>
			<div className="background-filter" onClick={handleClose} />
			<div className="popup-outer">
				<div className="popup-inner" id="popup-inner">
					<img
						id="purple-loading-spinner"
						src={WhiteLoadingSpinner}
						alt="Loading spinner"
					/>
					<h6 className="loading-spinner-popup-h6">{message}</h6>
				</div>
			</div>
		</div>
	);
};

export default LoadingSpinner;
